import { v4 } from './chunk-CW6A3IUB.js';
import { filtrerInput } from './chunk-IK5UEBSD.js';
import { extractPatternUrl } from './chunk-XBLLUWHJ.js';
import { format } from 'date-fns/format';
import URI from 'urijs';

var HEADER_X_SOURCE = "X-Source";
var HEADER_TRACKER_ID = "trackerId";
var HEADER_X_REQUEST_ID = "X-Request-Id";
var HEADER_X_ACTION_ID = "X-Action-Id";
var HEADER_X_MESSAGE_ID = "X-Message-Id";
var DATE_FORMAT_PRISME = "yyyy-MM-dd'T'HH:mm:ss.SSSXX";
var HEADER_REQUEST_TIME = "X-Request-Time";
function buildContext(prismeConfig, {
  headers,
  userInfoProvider,
  ...specifiqueMetier
}) {
  const userInfos = userInfoProvider?.() ?? prismeConfig.userInfoProvider?.() ?? {};
  const ctx = {
    requestId: getCaseInsensitive(headers ?? {}, HEADER_X_REQUEST_ID) || v4(),
    actionId: getCaseInsensitive(headers ?? {}, HEADER_X_ACTION_ID) || v4(),
    messageId: getCaseInsensitive(headers ?? {}, HEADER_X_MESSAGE_ID) || v4(),
    source: getCaseInsensitive(headers ?? {}, HEADER_X_SOURCE) || prismeConfig.st,
    trackerId: getCaseInsensitive(headers ?? {}, HEADER_TRACKER_ID) || prismeConfig.getTrackerId(),
    location_origin: globalThis?.location?.origin,
    location_pathname: globalThis?.location?.pathname,
    location_href: globalThis?.location?.href,
    ...userInfos,
    ...specifiqueMetier
  };
  return ctx;
}
function buildEvent(prismeConfig, currentTime, enErreur) {
  return {
    idEv: v4(),
    nom: `${prismeConfig.st}_Evenement`,
    date: format(currentTime, DATE_FORMAT_PRISME),
    timestamp: currentTime,
    // @CAVEAT: severite will be overidden when building a log
    severite: enErreur ? "ERROR" : "INFO",
    priorite: enErreur ? "3" : "6",
    emetteur: "LoggeurPrismeIHM"
  };
}
function buildExecAppelRest(prismeConfig, currentTime, headers, url, method, input, status, erreur) {
  const evenement = buildEvent(prismeConfig, currentTime, !!erreur);
  const requestTime = headers[HEADER_REQUEST_TIME] ? parseInt(headers[HEADER_REQUEST_TIME]) : void 0;
  let nom = `APPELRS`;
  let host;
  let port;
  let urlPattern;
  let pathname;
  if (url != null) {
    if (url.startsWith("http")) {
      const urlObj = URI(url);
      host = urlObj.hostname();
      port = urlObj.port() ? parseInt(urlObj.port()) : void 0;
      pathname = urlObj.pathname();
    } else {
      host = typeof window !== "undefined" ? window?.location?.origin : "";
      pathname = url;
    }
    urlPattern = extractPatternUrl(url);
    const pathnamePattern = extractPatternUrl(pathname);
    nom += `_${pathnamePattern}`;
  }
  let inputFinal;
  if (!prismeConfig.disableInput) {
    const inputFinalObj = filtrerInput(
      input,
      prismeConfig.additionalInputFilters
    );
    inputFinal = inputFinalObj == null ? void 0 : JSON.stringify(inputFinalObj).substring(0, 31990);
  }
  const execAppelRest = {
    ...evenement,
    typeEv: "APPELRESS",
    nom,
    debut: requestTime ? format(requestTime, DATE_FORMAT_PRISME) : void 0,
    fin: format(currentTime, DATE_FORMAT_PRISME),
    duree: requestTime ? currentTime - requestTime : void 0,
    enErreur: !!erreur,
    erreur,
    url,
    urlPattern,
    headers: maskAuthHeaders(headers),
    host,
    port,
    httpMethod: method || "get",
    httpStatus: status?.toString(),
    input: inputFinal
  };
  return execAppelRest;
}
function maskAuthHeaders(headers) {
  const headersFinaux = { ...headers };
  Object.keys(headers).forEach((key) => {
    if (/authorization/i.test(key)) {
      headersFinaux[key] = headersFinaux[key].substring(0, 14) + "**HIDDEN**";
    }
  });
  return headersFinaux;
}
function buildLog({
  action,
  currentTime,
  erreur,
  logName,
  message,
  config,
  severity
}) {
  const event = buildEvent(config, currentTime, !!erreur);
  let erreurFinale;
  if (erreur && erreur instanceof Error) {
    erreurFinale = {
      code: erreur.name,
      description: erreur.message,
      type: "TECHNIQUE",
      declencheur: erreur.stack,
      origine: erreur.stack?.split(/\n/)[0]
    };
  } else {
    erreurFinale = erreur;
  }
  return {
    ...event,
    action,
    erreur: erreurFinale,
    message,
    nom: logName ?? "LOG",
    severite: severity ?? "INFO",
    typeEv: "LOG"
  };
}
function augmentTrackingHeaders(st, trackerId, headersExistants) {
  const headers = headersExistants || {};
  if (!getCaseInsensitive(headers, HEADER_X_SOURCE))
    headers[HEADER_X_SOURCE] = st;
  if (!getCaseInsensitive(headers, HEADER_X_REQUEST_ID))
    headers[HEADER_X_REQUEST_ID] = v4();
  if (!getCaseInsensitive(headers, HEADER_X_ACTION_ID))
    headers[HEADER_X_ACTION_ID] = v4();
  if (!getCaseInsensitive(headers, HEADER_X_MESSAGE_ID))
    headers[HEADER_X_MESSAGE_ID] = v4();
  if (!getCaseInsensitive(headers, HEADER_TRACKER_ID))
    headers[HEADER_TRACKER_ID] = trackerId;
  if (!getCaseInsensitive(headers, HEADER_REQUEST_TIME))
    headers[HEADER_REQUEST_TIME] = Date.now().toString();
  return headers;
}
function getUserInfosFromHeaders(headers) {
  return {
    // @FIXME: x-oauth2-idpersonne ou x-oauth2-idpersonne-identifiee
    idPersonne: headers["x-oauth2-idpersonne"],
    userType: headers["x-oauth2-usertype"],
    login: headers["x-oauth2-login"]
  };
}
function getCaseInsensitive(obj, property) {
  return obj?.[Object.keys(obj || {}).find(
    (prop) => prop.toLowerCase() === property.toLowerCase()
  ) || ""];
}

export { DATE_FORMAT_PRISME, HEADER_REQUEST_TIME, HEADER_TRACKER_ID, HEADER_X_ACTION_ID, HEADER_X_MESSAGE_ID, HEADER_X_REQUEST_ID, HEADER_X_SOURCE, augmentTrackingHeaders, buildContext, buildEvent, buildExecAppelRest, buildLog, getUserInfosFromHeaders };
//# sourceMappingURL=chunk-JPNTSM5L.js.map
//# sourceMappingURL=chunk-JPNTSM5L.js.map